import axios from "axios";

export const getJobGroups = (careersClientId, jobType) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/jobgroups/" +
        encodeURIComponent(careersClientId) +
        "/" +
        encodeURIComponent(jobType)
    )
    .then((res) => res.data);
};

export const editJobGroup = (jobGroupId, jobGroup) => {
  return axios
    .put(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/jobgroups/editjobgroup/" +
        encodeURIComponent(jobGroupId),
      jobGroup
    )
    .then((res) => res.data);
};
